export default __webpack_public_path__ + "static/media/Warlord's Crossbow.fdb2f9df.jpg";